




















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '../../../api/v2/api'
import Comment from '../../../api/v2/models/comment'
import CommentForm from '../../../api/v2/forms/comment'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import ButtonBack from '../atoms_molecules/ButtonBack.vue'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import Inquiry from '../../../api/v2/models/inquiry'
import InquiryView from '../atoms_molecules/InquiryView.vue'
import UserInquiryDialog from '../organisms/UserInquiryDialog.vue'
import { ROUTER_NAME } from '../../router'
@Component({
  components: {
    ConfirmDialog,
    UserInquiryDialog,
    Simplemde,
    ButtonBack,
    InquiryView,
  }
})
export default class UserQuestionDetail extends Vue {
  inquiry: Inquiry | null = null
  newComment: string = ''
  $refs: {
    confirm: ConfirmDialog
  }
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: '問い合わせ一覧',
      disabled: false,
      exact: true,
      to: '/classroom/inquiries'
    }
  ]

  get user() {
    return userState.user
  }

  created() {
    this.getInquiry()
  }

  async getInquiry(){
    try {
      this.inquiry = await api.inquiry.show(this.$route.params.inquiryId)
      headerState.setTitle(this.inquiry.title)

      this.breadcrumbs.push({
        text: this.inquiry.title,
        disabled: true,
        exact: false,
        to: ''
      })
    } catch(e) {
    } finally {
    }
  }

  updated() {
    this.$nextTick(() => {
      if (this.$route.hash) {
        const el = document.querySelector(this.$route.hash)
        el && el.scrollIntoView()
      }
    })
  }

  async createComment() {
    try {
      const commentForm = new CommentForm()
      commentForm.body = this.newComment
      commentForm.commentableId = parseInt(this.$route.params.inquiryId)
      commentForm.commentableType = 'Inquiry'
      await api.comment.create(commentForm)

      this.newComment = ''
      this.inquiry = await api.inquiry.show(this.$route.params.inquiryId)
      this.inquiry.showCommentForm = false
    } catch(e) {
    } finally {
    }
  }

  async updateComment(comment: Comment) {
    try {
      await api.comment.update(comment.id, { body: comment.body })
      comment.isEditing = false
      this.inquiry = await api.inquiry.show(this.$route.params.inquiryId)
    } catch(e) {
    } finally {
    }
  }


  async deleteComment(commentId: number) {
    try {
      if (await (this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.comment.delete(commentId)
        this.inquiry = await api.inquiry.show(this.$route.params.inquiryId)
      }
    } catch(e) {
    } finally {
    }
  }

  @Watch('$route')
  async changeRoute(val, oldVal) {
    try {
      this.inquiry = await api.inquiry.show(this.$route.params.inquiryId)
      headerState.setTitle(this.inquiry.title)
    } catch(e) {
    } finally {
    }
  }

  async deleteInquiry(id: number) {
    try {
      if (await (this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.inquiry.delete(id)

        this.$router.push({
          name: ROUTER_NAME.INQUIRY_LIST,
        })
      }
    } catch(e) {
    } finally {
    }
  }

}
